import React, { useEffect, useState } from "react";

export default function SplashScreen({ onFinish }) {
    const [opacity, setOpacity] = useState(1); 
    
    const [yPosition, setYPosition] = useState(20); 

    useEffect(() => {
        const totalDuration = 2000; 
        const intervalTime = 30;    
        const steps = totalDuration / intervalTime; 
        
        const finishTimer = setTimeout(() => {
            onFinish();
        }, totalDuration);

        const opacityDecrement = 1 / steps; 
        const yDecrement = 20 / steps;              
        let currentOpacity = 1;
        let currentY = 20;

        const animationInterval = setInterval(() => {
            currentOpacity -= opacityDecrement;
            currentY -= yDecrement;
            
            if (currentOpacity <= 0) { 
                currentOpacity = 0;
                clearInterval(animationInterval);
            }
            
            setOpacity(currentOpacity);
            setYPosition(currentY);
        }, intervalTime); 

        return () => {
            clearTimeout(finishTimer);
            clearInterval(animationInterval); 
        };
    }, [onFinish]);

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "#f5f5f5",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: "column",
            }}
        >
            <img
                src="/images/p2025 LOGO DOUTOR PORTÕES.png"
                alt="Logo"
                style={{
                    width: "70vw",
                    maxWidth: "400px",
                    height: "auto",
                    marginBottom: "20px",
                    opacity: opacity, 
                    transform: `translateY(${yPosition}px)`, 
                    transition: "all 0.03s linear", 
                }}
            />
        </div>
    );
}